var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list',{staticClass:"scrollable-list"},_vm._l((_vm.timeList),function(item,index){return _c('v-list-item',{key:index,attrs:{"link":""},on:{"click":function($event){return _vm.$emit('selected',item)}}},[_c('v-list-item-title',{attrs:{"id":_vm.uniqueId + item.replace(':','').replace(' ','')}},[_vm._v(_vm._s(item))])],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }